/* =========================================================
   AP CSP QOTD HUB (JSON + PAGINATION — NO ATOM FEED)
   - Fetches ALL posts via /blogs/<handle>/articles.json (paged)
   - Extracts day # from title
   - Picks best canonical post per day (scoring)
   - Builds Cycle 1 Days 1–30 reliably
   ========================================================= */

(function () {
  // ---- config ----
  var ACC_ID = "dp-accordion";
  var BLOG_HANDLE = "ap-csp-daily-practice";
  var LIMIT = 250;

  var MIN_DAY = 1;
  var MAX_DAY = 30;

  var ROTATION_LENGTH = 121;
  var CYCLE_SIZE = 30;

  // Jan 6, 2026 (UTC) — keep this aligned with your existing logic
  var START_UTC = Date.UTC(2026, 0, 6);

  // Tune these to your actual placeholder patterns
  var PLACEHOLDER_TITLE_KEYWORDS = [
    "placeholder",
    "coming soon",
    "test",
    "draft",
    "temp"
  ];

  // Prefer these handle prefixes (canonical series)
  var PREFERRED_HANDLE_PREFIXES = [
    "csp-c1-day-",
    "csp-c2-day-",
    "csp-c3-day-",
    "csp-c4-day-",
    "csp-c5-day-"
  ];

  // ---- helpers ----
  function $(id) { return document.getElementById(id); }

  function utcDayStamp(d) {
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  }

  function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }

  function formatDate(d) {
    // simple local-ish display from UTC date object
    var yyyy = d.getUTCFullYear();
    var mm = String(d.getUTCMonth() + 1).padStart(2, "0");
    var dd = String(d.getUTCDate()).padStart(2, "0");
    return yyyy + "-" + mm + "-" + dd;
  }

  function computeState() {
    var now = new Date();
    var todayUTC = utcDayStamp(now);
    var dayIndex = Math.floor((todayUTC - START_UTC) / 86400000) + 1; // 1-based
    var currentDay = ((dayIndex - 1) % ROTATION_LENGTH) + 1;

    // “releasedDays” gate: you can keep this simple (all released)
    // or make it time-based; keeping your intent:
    var releasedDays = clamp(dayIndex, 1, ROTATION_LENGTH);

    return {
      now: now,
      currentDay: currentDay,
      releasedDays: releasedDays
    };
  }

  function extractDayNumber(title) {
    if (!title) return null;

    // Accept: "AP CSP Day 12:", "Day 12:", "APCSP Day 12", "CSP Day 12"
    var m = title.match(/\bday\s*(\d{1,3})\b/i);
    if (!m) return null;

    var n = parseInt(m[1], 10);
    if (!isFinite(n) || n < 1 || n > 999) return null;
    return n;
  }

  function parseTopicFromTitle(title) {
    if (!title) return "Practice";

    var t = title;

    // Remove leading program labels (flexible)
    t = t.replace(/^ap\s*csp\s*/i, "");
    t = t.replace(/^csp\s*/i, "");

    // Remove "Day X:" prefix
    t = t.replace(/^day\s*\d{1,3}\s*:\s*/i, "");

    // Remove trailing cycle markers
    t = t.replace(/\s*\|\s*cycle\s*\d+\s*$/i, "");
    t = t.replace(/\s*\(\s*cycle\s*\d+\s*\)\s*$/i, "");

    // Cleanup
    t = t.trim();
    return t || "Practice";
  }

  function isPlaceholderTitle(title) {
    if (!title) return false;
    var lower = title.toLowerCase();
    for (var i = 0; i < PLACEHOLDER_TITLE_KEYWORDS.length; i++) {
      if (lower.indexOf(PLACEHOLDER_TITLE_KEYWORDS[i]) !== -1) return true;
    }
    return false;
  }

  function scoreCandidate(a) {
    // a: article object from Shopify JSON
    // Higher score wins
    var s = 0;

    var title = (a && a.title) ? a.title : "";
    var handle = (a && a.handle) ? a.handle : "";

    // Big penalty for placeholders
    if (isPlaceholderTitle(title)) s -= 1000;

    // Prefer canonical handle prefixes
    for (var i = 0; i < PREFERRED_HANDLE_PREFIXES.length; i++) {
      if (handle.indexOf(PREFERRED_HANDLE_PREFIXES[i]) === 0) {
        s += 200;
        break;
      }
    }

    // Prefer titles that explicitly look like your canonical format
    if (/ap\s*csp\s*day\s*\d{1,3}\s*:/i.test(title)) s += 80;
    if (/^day\s*\d{1,3}\s*:/i.test(title)) s += 30;

    // Prefer more descriptive titles (topic present)
    if (title.length >= 18) s += 10;

    // Slight preference for published posts (should always be true here)
    if (a && a.published_at) s += 5;

    return s;
  }

  function buildDayMap(articles) {
    var best = {}; // best[day] = {day, topic, href, score, title, handle}

    for (var i = 0; i < articles.length; i++) {
      var a = articles[i];
      if (!a || !a.title || !a.handle) continue;

      var day = extractDayNumber(a.title);
      if (day == null) continue;
      if (day < MIN_DAY || day > MAX_DAY) continue;

      var candidate = {
        day: day,
        topic: parseTopicFromTitle(a.title),
        href: "/blogs/" + BLOG_HANDLE + "/" + a.handle,
        score: scoreCandidate(a),
        title: a.title,
        handle: a.handle
      };

      if (!best[day] || candidate.score > best[day].score) {
        best[day] = candidate;
      }
    }

    // Normalize list Days 1–30 (missing => disabled tile)
    var days = [];
    for (var d = MIN_DAY; d <= MAX_DAY; d++) {
      if (best[d]) {
        days.push({ day: best[d].day, topic: best[d].topic, href: best[d].href });
      } else {
        days.push({ day: d, topic: "Coming Soon", href: null });
      }
    }

    return days;
  }

  // ---- UI builders (uses your existing markup conventions) ----
  function buildTile(obj, state) {
    var a = document.createElement("a");
    a.className = "dp-day-tile";

    var day = obj.day;
    var isReleased = (day <= state.releasedDays);

    if (obj.href && isReleased) {
      a.href = obj.href;
      a.classList.remove("disabled");
    } else {
      a.href = "#";
      a.classList.add("disabled");
    }

    a.innerHTML =
      '<div class="dp-day-num">Day ' + day + '</div>' +
      '<div class="dp-day-topic">' + escapeHtml(obj.topic) + "</div>";

    return a;
  }

  function buildCycle(cycleNum, title, subtitle, desc, dayList, state, expanded) {
    var wrap = document.createElement("div");
    wrap.className = "dp-cycle";

    var header = document.createElement("button");
    header.type = "button";
    header.className = "dp-cycle-header";
    header.setAttribute("aria-expanded", expanded ? "true" : "false");

    header.innerHTML =
      '<div class="dp-cycle-title">' + escapeHtml(title) + "</div>" +
      '<div class="dp-cycle-sub">' + escapeHtml(subtitle) + "</div>";

    var body = document.createElement("div");
    body.className = "dp-cycle-body";
    if (!expanded) body.style.display = "none";

    var p = document.createElement("div");
    p.className = "dp-cycle-desc";
    p.textContent = desc || "";

    var grid = document.createElement("div");
    grid.className = "dp-day-grid";

    for (var i = 0; i < dayList.length; i++) {
      grid.appendChild(buildTile(dayList[i], state));
    }

    body.appendChild(p);
    body.appendChild(grid);

    header.addEventListener("click", function () {
      var open = header.getAttribute("aria-expanded") === "true";
      header.setAttribute("aria-expanded", open ? "false" : "true");
      body.style.display = open ? "none" : "block";
    });

    wrap.appendChild(header);
    wrap.appendChild(body);
    return wrap;
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  // ---- fetching (paged) ----
  function fetchArticlesPage(page) {
    var url = "/blogs/" + BLOG_HANDLE + "/articles.json?limit=" + LIMIT + "&page=" + page;
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (j) {
        return (j && j.articles) ? j.articles : [];
      });
  }

  function fetchAllArticles(maxPages) {
    var all = [];
    var page = 1;

    function next() {
      if (page > maxPages) return Promise.resolve(all);

      return fetchArticlesPage(page).then(function (items) {
        if (!items || items.length === 0) return all;
        for (var i = 0; i < items.length; i++) all.push(items[i]);

        // If fewer than LIMIT, likely last page
        if (items.length < LIMIT) return all;

        page += 1;
        return next();
      });
    }

    return next();
  }

  // ---- mount ----
  function mount(days) {
    var acc = $(ACC_ID);
    if (!acc) return;

    var state = computeState();

    // Badge
    var badge = $("dp-date-badge");
    if (badge) badge.textContent = "Day " + state.currentDay + " of " + ROTATION_LENGTH + " • " + formatDate(state.now);

    // Today card
    var todayObj = null;
    for (var i = 0; i < days.length; i++) {
      if (days[i].day === state.currentDay) { todayObj = days[i]; break; }
    }
    if (!todayObj) todayObj = days[0];

    var todayCard = $("today-card");
    var todayUnit = $("today-unit");
    var todayTitle = $("today-title");
    var todaySection = $("today-section");

    if (todayUnit) todayUnit.textContent = "AP CSP";
    if (todayTitle && todayObj) todayTitle.textContent = "Day " + todayObj.day + ": " + todayObj.topic;
    if (todaySection) todaySection.textContent = (todayObj && todayObj.href) ? "Click to start" : "Releases soon";

    if (todayCard) {
      if (todayObj && todayObj.href && (todayObj.day <= state.releasedDays)) {
        todayCard.href = todayObj.href;
        todayCard.classList.remove("disabled");
      } else {
        todayCard.href = "#";
        todayCard.classList.add("disabled");
      }
    }

    // Accordion
    acc.innerHTML = "";
    acc.appendChild(buildCycle(
      1,
      "Foundation (Days 1–30)",
      "Auto-mapped to your REAL blog URLs",
      "These links are pulled from your published blog post handles (no guessing, no feed cap).",
      days,
      state,
      true
    ));
  }

  function init() {
    if (!$(ACC_ID)) return;

    // 10 pages * 250 = 2500 articles (way more than you have)
    fetchAllArticles(10)
      .then(function (articles) {
        var days = buildDayMap(articles);
        mount(days);
      })
      .catch(function () {
        // fail silently (don’t break the page)
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();